export const SET_FILTERS = 'SET_FILTERS';
export const CLEAR_FILTER = 'CLEAR_FILTER';
